// actions.js
export const SET_SELECTED_STATE = 'SET_SELECTED_STATE';
export const SET_SELECTED_LGA = 'SET_SELECTED_LGA';

export const setSelectedState = (state) => ({
  type: SET_SELECTED_STATE,
  payload: state,
});


export const setSelectedLGA = (lga) => ({
    type: SET_SELECTED_LGA,
    payload: lga,
  });